import { useQuery } from '@tanstack/react-query';
import { API_URL } from '../lib/api';

export interface Order {
  id: string;
  totalAmount: number;
  currency: string;
  createdAt: string;
  status: string;
  product: {
    id: string;
    name: string;
  } | null;
}

interface OrdersResponse {
  items: Order[];
}

async function fetchOrders(): Promise<Order[]> {
  const response = await fetch(`${API_URL}/api/v2/cloud/orders`, {
    credentials: 'include',
  });

  if (!response.ok) {
    return [];
  }

  const data: OrdersResponse = await response.json();
  return data.items ?? [];
}

export function useOrders() {
  const { data, isLoading } = useQuery({
    queryKey: ['orders'],
    queryFn: fetchOrders,
    staleTime: 60_000,
    gcTime: 5 * 60_000,
    retry: false,
  });

  return {
    orders: data ?? [],
    isLoading,
  };
}
